<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="회원사 관리" device="web" :IsUseSearchRequirement="true">
        <template v-slot:SearchRequirement>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between align-center">
              <v-select
                style="width:120px;"
                :menu-props="{ offsetY: true }"
                color="primary"
                item-text="minorNm"
                item-value="minorCd"
                :items="rgstDiv"
                placeholder="가입구분"
                solo
                max-width="100px"
                class="editor_bg"
                v-model="searchRgstDivCd"
                @change="btnSearch(true)"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:body>
          <DxDataGrid
            id="clntMemberDataGrid"
            width="100%"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :selection="{ mode: 'single' }"
            key-expr="id"
            :focused-row-enabled="true"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing :allow-updating="true" mode="batch" :select-text-on-edit-start="true" />
            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
            <DxColumn
              css-class="devest-grid-header-require"
              data-field="rgstNo"
              data-type="string"
              width="300px"
              alignment="center"
              caption="사업자 등록 번호"
            />
            <DxColumn data-field="joinDiv" width="0px" data-type="string"></DxColumn>

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="clntNm"
              data-type="string"
              width="300px"
              alignment="center"
              caption="고객사명"
              :allow-editing="true"
            />
            <DxColumn
              data-field="licenseCd"
              data-type="string"
              width="250px"
              alignment="center"
              caption="면허번호"
              :allow-editing="true"
            />
            <DxColumn
              data-field="userCd"
              data-type="string"
              width="180px"
              alignment="center"
              caption="등록된 계정"
              :allow-editing="false"
            />
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right
        headerTitle
        :useBtnList="buttonUseList"
        @btnSearch="btnSearch(true)"
        @btnAdd="btnAdd()"
        @btnSave="btnSave()"
        @btnDelete="btnDelete()"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>
  
<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

import { getCommonCode } from '@/api/common/commonApi'
import { getClientMemberList, saveClientMemberData, deleteClientMemberData } from '@/api/adminManagement/clientMemberManage.js'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'clientMemberManage',
  components: {
    'i-card-vertical': iCardVertical
  },
  data() {
    return {
      dxDataGridRef: 'clntGridRef',
      gridMain: [],
      rgstDiv: [], // 회원가입 구분
      searchRgstDivCd: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', // 저장
        'btnDelete' // 삭제
      ]
    }
  },
  activated() {},
  watch: {
    searchRgstDivCd() {
      this.btnSearch(true)
    }
  },
  computed: {},
  beforeMount() {},
  created() {
    // 고객 회원가입 구분
    getCommonCode('CP001')
      .then(res => {
        if (res.success) {
          this.rgstDiv = res.list
          this.searchRgstDivCd = res.list[0].minorCd
        }
      })
      .catch(() => {})
      .finally(() => {
        this.btnSearch(true)
      })
  },
  mounted() {},
  methods: {
    //------------------------------------------
    //  버튼 이벤트
    //------------------------------------------
    btnSearch(notify = false) {
      let params = {
        clntId: this.getClntId(),
        joinDiv: this.searchRgstDivCd
      }
      this.openLoading()
      getClientMemberList(params, notify)
        .then(res => {
          if (res.success) {
            this.gridMain = res.list
            if (res.list.length > 0) this.GetDataGrid(this.dxDataGridRef).clearSelection()
          }
        })
        .catch(err => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnAdd() {
      console.log('@ ', (this.gridMain.length + '_' + new Date().getSeconds() + new Date().getMilliseconds()).toString())
      let newRow = {
        id: (this.gridMain.length + '_' + new Date().getSeconds() + new Date().getMilliseconds()).toString(),
        rgstNo: '',
        clntNm: '',
        joinDiv: this.searchRgstDivCd,
        licenseCd: '',
        __created__: true
      }
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          console.log('@@ selectedRows', selectedRows)
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          let valid = selectedRows.findIndex(el => !el.rgstNo || !el.clntNm)
          if (valid >= 0) {
            this.vToastify(this.$t('필수항목 입력하세요.'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              // this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.openLoading('')
              try {
                saveClientMemberData(selectedRows, true).then(res => {
                  this.btnSearch()
                })
              } catch (error) {
                this.endLoading()
              } finally {
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    async btnDelete() {
      let selectedMainRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()

      if (!selectedMainRows.length) {
        this.vToastify(this.$t('삭제할 데이터를 선택해주세요.'), 'info')
        return
      }

      this.vToastifyPrompt(
        this.$t('선택한 데이터를 삭제하시겠습니까?'),
        'info',
        async () => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          this.openLoading()
          try {
            await deleteClientMemberData(selectedMainRows, true)
            this.btnSearch(false)
          } catch (error) {
            console.error('deleteClientMemberApproval error catch >> ', error)
          } finally {
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            this.endLoading()
          }
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  etc 이벤트
    //------------------------------------------
    onEditingStart(e) {
      if (!e.data.__created__ && e.column.dataField === 'rgstNo') {
        e.cancel = true
      }
    },
    onEditorPreparing(e) {
      // onCellValueChanged 를 사용하기 위함
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
      if (e.parentType === 'dataRow' && !e.row.data.__created__ && e.column) {
        if (e.column.dataField === 'rgstNo') {
          e.editorOptions.readOnly = true
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      if (cellInfo.dataField == 'rgstNo') {
        let rgstNoPattern = /^[0-9]{3}-[0-9]{2}-[0-9]{5}$/
        if (!value || !rgstNoPattern.test(value)) {
          this.vSnackbar(this.$t('올바르지 않은 사업자 등록번호 형식입니다. ex)000-00-00000'), 'warn', 2000)
          value = ''
          return
        }
      }
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
      // this.GetDataGrid(this.dxDataGridRef).saveEditData()
    }
  }
}
</script>
  
  <style scoped></style>
  